import { Application } from '@hotwired/stimulus';
// eslint-disable-next-line import/no-unresolved
import StimulusControllerResolver, { createViteGlobResolver } from 'stimulus-controller-resolver';

const application = Application.start();

const controllers = import.meta.glob('./controllers/**/*_controller.{js,jsx}');
const paths = createViteGlobResolver(controllers);
StimulusControllerResolver.install(application, paths);
